var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBars = function SvgBars(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 165,
    viewBox: "0 0 170 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0488281,
    y: 100.46,
    width: 28.6696,
    height: 64.359,
    rx: 14.3348,
    fill: "#B8AEF1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46.8252,
    y: 76.6235,
    width: 28.6696,
    height: 88.1957,
    rx: 14.3348,
    fill: "#82C6FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 93.6025,
    y: 36.1011,
    width: 28.6696,
    height: 128.718,
    rx: 14.3348,
    fill: "#FFD67C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 140.379,
    y: 0.346191,
    width: 28.6696,
    height: 164.473,
    rx: 14.3348,
    fill: "#8ED6C9"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBars);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTcwIiBoZWlnaHQ9IjE2NSIgdmlld0JveD0iMCAwIDE3MCAxNjUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjAuMDQ4ODI4MSIgeT0iMTAwLjQ2IiB3aWR0aD0iMjguNjY5NiIgaGVpZ2h0PSI2NC4zNTkiIHJ4PSIxNC4zMzQ4IiBmaWxsPSIjQjhBRUYxIi8+CjxyZWN0IHg9IjQ2LjgyNTIiIHk9Ijc2LjYyMzUiIHdpZHRoPSIyOC42Njk2IiBoZWlnaHQ9Ijg4LjE5NTciIHJ4PSIxNC4zMzQ4IiBmaWxsPSIjODJDNkZGIi8+CjxyZWN0IHg9IjkzLjYwMjUiIHk9IjM2LjEwMTEiIHdpZHRoPSIyOC42Njk2IiBoZWlnaHQ9IjEyOC43MTgiIHJ4PSIxNC4zMzQ4IiBmaWxsPSIjRkZENjdDIi8+CjxyZWN0IHg9IjE0MC4zNzkiIHk9IjAuMzQ2MTkxIiB3aWR0aD0iMjguNjY5NiIgaGVpZ2h0PSIxNjQuNDczIiByeD0iMTQuMzM0OCIgZmlsbD0iIzhFRDZDOSIvPgo8L3N2Zz4K";